// api
import PresentationApi from '@/api/presentation'
import router from '@/router'
// 3rd parties

const setPresentationsAction = ({ commit }, payload) => {
  commit('setPresentations', payload)
}

const getPresentationsAction = async ({ commit, state }, payload = {}) => {
  const res = await PresentationApi.getPresentations(payload)

  // Fix AHA-5419
  if (router.currentRoute.name === 'SharedWithMe') return
  const { presentations, numberOfPresentationPages } = res
  if (payload.page === 1) {
    commit('setPresentations', presentations)
  } else {
    commit('setPresentations', [...state.presentations, ...presentations])
  }

  commit('setNumberOfPresentationPages', numberOfPresentationPages)
}

const searchPresentationsAction = async ({ commit, state }, payload = {}) => {
  const res = await PresentationApi.searchPresentations(payload)

  const { presentations, numberOfPresentationPages } = res
  if (payload.page === 1) {
    commit('setPresentations', presentations)
  } else {
    commit('setPresentations', [...state.presentations, ...presentations])
  }

  commit('setNumberOfPresentationPages', numberOfPresentationPages)
}

const getSharedPresentationsAction = async ({ commit, state, rootGetters }, payload = {}) => {
  if (rootGetters['multipleSessions/canInvitePresenterToFolder']) {
    payload = { ...payload, batchShareAsPresenter: true }
  }
  const res = await PresentationApi.getSharedPresentations(payload)
  // Fix AHA-5419
  const { presentations, numberOfPresentationPages } = res
  if (payload.page === 1) {
    commit('setPresentations', presentations)
  } else {
    commit('setPresentations', [...state.presentations, ...presentations])
  }

  commit('setNumberOfPresentationPages', numberOfPresentationPages)
}

export default {
  searchPresentationsAction,
  setPresentationsAction,
  getPresentationsAction,
  getSharedPresentationsAction,
}
